import { IcoTag } from '@components/icons';
import { ManagedTag } from './state';
import { FilterMenu, FilterOption } from './filter-menu';

export function TagFilter({
  tags,
  value,
  onChange,
  onManage,
}: {
  tags: ManagedTag[];
  value?: string;
  onChange(id?: string): void;
  onManage?(): void;
}) {
  const label =
    tags.find((tag) => tag.id === value)?.name ?? (value ? 'Unavailable tag' : undefined);
  return (
    <FilterMenu
      id="media-tag-filter-trigger"
      icon={IcoTag}
      label={label ?? 'All tags'}
      active={!!value}
      triggerLabel={label ? `Tag: ${label}` : 'All tags'}
      menuLabel="Filter by tag"
      searchLabel="Search tags"
    >
      {({ matches, choose, close }) => {
        const visible = tags.filter((tag) => matches(tag.name));
        return (
          <>
            <div class="max-h-64 overflow-y-auto">
              <FilterOption
                selected={!value}
                label="All tags"
                onClick={() => choose(() => onChange(undefined))}
              />
              {visible.map((tag) => (
                <FilterOption
                  key={tag.id}
                  selected={tag.id === value}
                  label={tag.name}
                  onClick={() => choose(() => onChange(tag.id))}
                />
              ))}
              {visible.length === 0 && (
                <p class="p-2 text-sm text-gray-500">
                  {tags.length === 0 ? 'No tags yet' : 'No tags match your search'}
                </p>
              )}
            </div>
            {onManage && (
              <div class="mt-1 border-t border-gray-200 pt-1">
                <button
                  type="button"
                  class="flex min-h-11 w-full items-center rounded-md px-2 text-left text-sm font-semibold text-indigo-700 hover:bg-indigo-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                  onClick={() => {
                    close();
                    requestAnimationFrame(onManage);
                  }}
                >
                  Manage tags…
                </button>
              </div>
            )}
          </>
        );
      }}
    </FilterMenu>
  );
}
